export default __webpack_public_path__ + "static/media/115.3da301ef.png";